<template>
  <div class="main">
    <div class="carmera">
      <video id="QRvideo" muted autoplay playsinline></video>
      <canvas id="qr-canvas"></canvas>
      <div class="tip">扫码查真伪</div>
      <div id="scan"></div>
    </div>
    <!-- <input type="file" id="file" name="image" accept="image/*,video/*" class="hidden" capture="camera" @change="paizhao" /> -->
  </div>
</template>

<script>
export default {
  data () {
    return {
      videoInputDevice: [], //设备列表
      videoElement: null,
      canvasElement: null,
      decodeTimer: null,
      canvasTimer: null,
      canvasContext: null,
      canvasData: ""
    }
  },
  mounted: function () {
    console.log(this.$route.params.id);
    this.videoElement = document.getElementById("QRvideo");
    this.canvasElement = document.getElementById("qr-canvas");
    this.canvasContext = document.getElementById("qr-canvas").getContext("2d");
    this.init();

  },
  methods: {
    init () {
      let that = this;
      // API参考
      // https://developer.mozilla.org/zh-CN/docs/Web/API/MediaDevices/enumerateDevices
      // 先获取设备列表，方便调用后置摄像头
      let devices = navigator.mediaDevices.enumerateDevices().then(that.gotDevices.bind(that));
      document.querySelector('#scan').addEventListener('click', () => {
        that.isScan = true;
        that.videoElement.play();
        devices.then(that.getStream.bind(that)).catch(that.handleError.bind(that));
        var hasRun = false; //避免重复执行回调函数
        // 结果回调
        qrcode.callback = (e) => {
          if (!hasRun) {
            // 清除画布，停止摄像头                  
            clearTimeout(that.decodeTimer);
            clearTimeout(that.canvasTimer);
            //that.canvasContext.clearRect(0, 0, 300, 200);
            if (window.stream) {
              window.stream.getTracks().forEach((track) => {
                track.stop();
              });
            }
            that.videoElement.style.display = 'none';

            //that.canvasElement.style.display = 'none';
            e = e.replace("httq://", "http://").replace("httqs://", "https://"); //这里有时会把http识别为httq，可在这一步替换
            if (e.indexOf("http://") != -1 || e.indexOf("https://") != -1) {
              hasRun = true;
              //这里可跳转到后台进行解密处理
              //window.location.href = e;
              //that.paizhao();
              //https://www.bjzd.ink/dist/#/
              window.location.href = 'https://www.bjzd.ink/dist/#/result/' + e.substring(e.lastIndexOf("/") + 1)
            } else {
              hasRun = false;
              alert("扫描错误，请重试！");
            }
          }
        }
      });
      setTimeout(() => {
        document.querySelector('#scan').click();
      }, 1000);
    },
    // 获取到的媒体设备
    gotDevices (deviceInfos) {
      let that = this;

      for (let i = 0; i !== deviceInfos.length; ++i) {
        let deviceInfo = deviceInfos[i];
        if (deviceInfo.kind === 'audioinput') {
          // 音频设备
        } else if (deviceInfo.kind === 'videoinput') {
          // 视频设备
          that.videoInputDevice.push(deviceInfo);
        } else {
          // 其他设备
          console.log('Found one other kind of source/device: ', deviceInfo);
        }
      }
    },
    getStream () {
      let that = this;
      if (window.stream) {
        window.stream.getTracks().forEach((track) => {
          track.stop();
        });
      }
      let constraints;
      if (that.isIOS) {
        constraints = {
          video: { facingMode: { exact: "environment" } }
        };
        console.log('3: ', constraints);
        // let constraints = {
        //   video: {
        //     // environment表示后置摄像头
        //     // user表示前置摄像头
        //     facingMode: ("environment")
        //   }
        // };
      } else {
        constraints = {
          // 包含audio 可声明音频设备调用
          // 声明视频设备调用
          // video: true
          video: {
            deviceId: {
              // [1].deviceId 表示后置摄像头,默认开启的是前置摄像头
              exact: that.videoInputDevice[1].deviceId
            }
          }
        };
      }
      // 视频设备初始化
      navigator.mediaDevices.getUserMedia(constraints).then(that.gotStream.bind(that)).catch(that.handleError.bind(that));
      that.captureToCanvas();
      that.decode();
    },
    // 解码
    decode () {
      let that = this;
      try {
        qrcode.decode();
      } catch (e) {
        console.log('1:' + e);
      };
      that.decodeTimer = setTimeout(that.decode.bind(that), 100); // 解码频率为100毫秒一次
    },

    //将视频流放到画布
    captureToCanvas () {
      let that = this;
      try {
        // 根据视频大小设置canvas大小
        let w = that.videoElement.videoWidth;
        let h = that.videoElement.videoHeight;
        that.canvasElement.width = w;
        that.canvasElement.height = h;
        that.canvasContext.scale(2, 2);
        that.canvasContext.drawImage(that.videoElement, 0, 0, w, h);
      } catch (e) {
        console.log(e);
      };
      // 100毫秒绘制一次
      that.canvasTimer = setTimeout(that.captureToCanvas.bind(that), 100);
    },
    handleError (error) {
      // alert('handleError');
      // if (ChkUtil.IsMobileDevice()) {
      //   if (error.toString().indexOf("TypeError: Cannot read property 'deviceId' of undefined") != -1) {
      //     alert("无法访问摄像头！请授予手机浏览器摄像头权限或切换至有摄像头权限的浏览器!");
      //   }
      // } else {
      //   console.log(error);
      // }
      console.log(error);
      return;
    },
    gotStream (stream) {
      let that = this;
      window.stream = stream; // make stream available to console
      that.videoElement.srcObject = stream;
    },
    isIOS () {
      var u = navigator.userAgent;
      var IOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (IOS) {
        return true;
      } else {
        return false;
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.main {
  position: fixed;
  width: 100%;
  height: 100%;

  .carmera {
    margin: 0 auto;
    box-sizing: border-box;
    width: 8.888889rem;
    height: 8.888889rem;
    position: relative;
    top: 50%;
    transform: translateY(-50%);

    video, canvas {
      width: 100%;
      height: 100%;
      border: 1px solid #ccc;
    }

    canvas {
      position: absolute;
      left: 0;
      top: 0;
    }
  }

  .tip {
    text-align: center;
    font-size: 0.388889rem;
    line-height: 1.111111rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/example01/index.vue